import {createSlice} from "@reduxjs/toolkit";
import {DATA_LIMIT} from "../../app/constants";

const saleCallSource = createSlice({
	name: "saleCallSource",
	initialState: {
		loading: false,
		error: null,
		filter: {
			page: 1,
			limit: DATA_LIMIT,
		},
		items: [],
		stats: {
			total: 0,
			called: 0
		},
		pagination: {
			page: 1,
			limit: DATA_LIMIT,
			total: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
			state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			state.pagination = action.payload.pagination;
			state.stats = action.payload.stats || { total: 0, called: 0 };
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		add(state, action) {
			state.items.unshift(action.payload);
			return state;
		},
		delete(state, action) {
			state.items = state.items.filter(function(item) {
				return item.id !== action.payload
			});
		},
		patchContact(state, action) {
			const { id, patch } = action.payload;
			state.items = state.items.map((item) => item.id === id ? { ...item, ...patch } : item);
			return state;
		},
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
		setFilterWithDebounce(state, action) {}
	}
});

export const saleCallSourceActions = saleCallSource.actions;
export const saleCallSourceReducer = saleCallSource.reducer;
export const saleCallSourceItemsSelector = (state) => state.saleCallSource.items;
export const saleCallSourceLoadingSelector = (state) => state.saleCallSource.loading;
export const saleCallSourceErrorSelector = (state) => state.saleCallSource.error;
export const saleCallSourceFilterSelector = (state) => state.saleCallSource.filter;
export const saleCallSourcePaginationSelector = (state) => state.saleCallSource.pagination;
export const saleCallSourceStatsSelector = (state) => state.saleCallSource.stats;

